// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App Settings Page Styles */

.settings-page {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
}

.settings-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 30px;
}

.settings-header h1 {
  margin: 0 0 8px;
  color: #333;
  font-size: 28px;
}

.settings-header p {
  margin: 0;
  color: #666;
}

.unsaved-badge {
  padding: 8px 16px;
  background: #fff3cd;
  color: #856404;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
}

/* Settings Tabs */
.settings-tabs {
  display: flex;
  gap: 5px;
  margin-bottom: 20px;
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
  overflow-x: auto;
}

.settings-tabs .tab {
  padding: 10px 20px;
  background: none;
  border: none;
  color: #666;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s;
  white-space: nowrap;
}

.settings-tabs .tab:hover {
  background: #f5f5f5;
  color: #333;
}

.settings-tabs .tab.active {
  background: #667eea;
  color: white;
}

/* Settings Content */
.settings-content {
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.settings-section h2 {
  margin: 0 0 25px;
  color: #333;
  font-size: 22px;
}

.setting-group {
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid #eee;
}

.setting-group:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.setting-group h3 {
  margin: 0 0 20px;
  color: #667eea;
  font-size: 16px;
  font-weight: 600;
}

.setting-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #f5f5f5;
}

.setting-item:last-child {
  border-bottom: none;
}

.setting-info {
  flex: 1 1;
}

.setting-info label {
  display: block;
  margin-bottom: 5px;
  color: #333;
  font-weight: 500;
  font-size: 15px;
}

.setting-info p {
  margin: 0;
  color: #999;
  font-size: 13px;
}

/* Toggle Switch */
.toggle {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 28px;
  flex-shrink: 0;
}

.toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.3s;
  border-radius: 28px;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 22px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}

.toggle input:checked + .toggle-slider {
  background-color: #667eea;
}

.toggle input:checked + .toggle-slider:before {
  transform: translateX(22px);
}

.toggle.maintenance-toggle input:checked + .toggle-slider {
  background-color: #dc3545;
}

/* Input Fields */
.setting-item input[type="text"],
.setting-item input[type="number"] {
  width: 150px;
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
}

.setting-item input:focus {
  outline: none;
  border-color: #667eea;
}

.setting-item select {
  width: 180px;
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
}

.setting-item select:focus {
  outline: none;
  border-color: #667eea;
}

/* Color Input */
.color-input {
  display: flex;
  align-items: center;
  gap: 10px;
}

.color-input input[type="color"] {
  width: 50px;
  height: 40px;
  padding: 0;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
}

.color-input span {
  font-family: monospace;
  font-size: 14px;
  color: #666;
}

/* Action Buttons */
.settings-actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  padding: 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.btn-primary {
  padding: 12px 24px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-primary:hover {
  background: #5568d3;
}

.btn-primary:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.btn-secondary {
  padding: 12px 24px;
  background: #f0f0f0;
  color: #333;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-secondary:hover {
  background: #e0e0e0;
}

/* Messages */
.error-message {
  background: #fee;
  border: 1px solid #fcc;
  color: #c33;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.success-message {
  background: #d4edda;
  border: 1px solid #c3e6cb;
  color: #155724;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
}

/* Loading */
.admin-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 18px;
  color: #666;
}

/* Responsive */
@media (max-width: 768px) {
  .settings-header {
    flex-direction: column;
    gap: 15px;
  }

  .unsaved-badge {
    width: fit-content;
  }

  .setting-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .setting-item input[type="text"],
  .setting-item input[type="number"],
  .setting-item select {
    width: 100%;
  }

  .settings-actions {
    flex-direction: column;
  }

  .settings-tabs {
    flex-wrap: nowrap;
  }

  .settings-tabs .tab {
    padding: 8px 15px;
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/AppSettings.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;;EAEE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;;;IAGE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":["/* App Settings Page Styles */\r\n\r\n.settings-page {\r\n  max-width: 1000px;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n}\r\n\r\n.settings-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.settings-header h1 {\r\n  margin: 0 0 8px;\r\n  color: #333;\r\n  font-size: 28px;\r\n}\r\n\r\n.settings-header p {\r\n  margin: 0;\r\n  color: #666;\r\n}\r\n\r\n.unsaved-badge {\r\n  padding: 8px 16px;\r\n  background: #fff3cd;\r\n  color: #856404;\r\n  border-radius: 20px;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Settings Tabs */\r\n.settings-tabs {\r\n  display: flex;\r\n  gap: 5px;\r\n  margin-bottom: 20px;\r\n  border-bottom: 2px solid #eee;\r\n  padding-bottom: 10px;\r\n  overflow-x: auto;\r\n}\r\n\r\n.settings-tabs .tab {\r\n  padding: 10px 20px;\r\n  background: none;\r\n  border: none;\r\n  color: #666;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  border-radius: 8px;\r\n  transition: all 0.2s;\r\n  white-space: nowrap;\r\n}\r\n\r\n.settings-tabs .tab:hover {\r\n  background: #f5f5f5;\r\n  color: #333;\r\n}\r\n\r\n.settings-tabs .tab.active {\r\n  background: #667eea;\r\n  color: white;\r\n}\r\n\r\n/* Settings Content */\r\n.settings-content {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 30px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.settings-section h2 {\r\n  margin: 0 0 25px;\r\n  color: #333;\r\n  font-size: 22px;\r\n}\r\n\r\n.setting-group {\r\n  margin-bottom: 30px;\r\n  padding-bottom: 30px;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.setting-group:last-child {\r\n  margin-bottom: 0;\r\n  padding-bottom: 0;\r\n  border-bottom: none;\r\n}\r\n\r\n.setting-group h3 {\r\n  margin: 0 0 20px;\r\n  color: #667eea;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n}\r\n\r\n.setting-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 15px 0;\r\n  border-bottom: 1px solid #f5f5f5;\r\n}\r\n\r\n.setting-item:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.setting-info {\r\n  flex: 1;\r\n}\r\n\r\n.setting-info label {\r\n  display: block;\r\n  margin-bottom: 5px;\r\n  color: #333;\r\n  font-weight: 500;\r\n  font-size: 15px;\r\n}\r\n\r\n.setting-info p {\r\n  margin: 0;\r\n  color: #999;\r\n  font-size: 13px;\r\n}\r\n\r\n/* Toggle Switch */\r\n.toggle {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 50px;\r\n  height: 28px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.toggle input {\r\n  opacity: 0;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.toggle-slider {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: #ccc;\r\n  transition: 0.3s;\r\n  border-radius: 28px;\r\n}\r\n\r\n.toggle-slider:before {\r\n  position: absolute;\r\n  content: \"\";\r\n  height: 22px;\r\n  width: 22px;\r\n  left: 3px;\r\n  bottom: 3px;\r\n  background-color: white;\r\n  transition: 0.3s;\r\n  border-radius: 50%;\r\n}\r\n\r\n.toggle input:checked + .toggle-slider {\r\n  background-color: #667eea;\r\n}\r\n\r\n.toggle input:checked + .toggle-slider:before {\r\n  transform: translateX(22px);\r\n}\r\n\r\n.toggle.maintenance-toggle input:checked + .toggle-slider {\r\n  background-color: #dc3545;\r\n}\r\n\r\n/* Input Fields */\r\n.setting-item input[type=\"text\"],\r\n.setting-item input[type=\"number\"] {\r\n  width: 150px;\r\n  padding: 10px 15px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n}\r\n\r\n.setting-item input:focus {\r\n  outline: none;\r\n  border-color: #667eea;\r\n}\r\n\r\n.setting-item select {\r\n  width: 180px;\r\n  padding: 10px 15px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n}\r\n\r\n.setting-item select:focus {\r\n  outline: none;\r\n  border-color: #667eea;\r\n}\r\n\r\n/* Color Input */\r\n.color-input {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.color-input input[type=\"color\"] {\r\n  width: 50px;\r\n  height: 40px;\r\n  padding: 0;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n}\r\n\r\n.color-input span {\r\n  font-family: monospace;\r\n  font-size: 14px;\r\n  color: #666;\r\n}\r\n\r\n/* Action Buttons */\r\n.settings-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 15px;\r\n  padding: 20px;\r\n  background: white;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.btn-primary {\r\n  padding: 12px 24px;\r\n  background: #667eea;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.btn-primary:hover {\r\n  background: #5568d3;\r\n}\r\n\r\n.btn-primary:disabled {\r\n  background: #ccc;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.btn-secondary {\r\n  padding: 12px 24px;\r\n  background: #f0f0f0;\r\n  color: #333;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.btn-secondary:hover {\r\n  background: #e0e0e0;\r\n}\r\n\r\n/* Messages */\r\n.error-message {\r\n  background: #fee;\r\n  border: 1px solid #fcc;\r\n  color: #c33;\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.success-message {\r\n  background: #d4edda;\r\n  border: 1px solid #c3e6cb;\r\n  color: #155724;\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n/* Loading */\r\n.admin-loading {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100vh;\r\n  font-size: 18px;\r\n  color: #666;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .settings-header {\r\n    flex-direction: column;\r\n    gap: 15px;\r\n  }\r\n\r\n  .unsaved-badge {\r\n    width: fit-content;\r\n  }\r\n\r\n  .setting-item {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 15px;\r\n  }\r\n\r\n  .setting-item input[type=\"text\"],\r\n  .setting-item input[type=\"number\"],\r\n  .setting-item select {\r\n    width: 100%;\r\n  }\r\n\r\n  .settings-actions {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .settings-tabs {\r\n    flex-wrap: nowrap;\r\n  }\r\n\r\n  .settings-tabs .tab {\r\n    padding: 8px 15px;\r\n    font-size: 13px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
